const FR_NAVIGATION_WIDTH = 105;

export const DEFAULT_FR_NAV_APP_CONTENT_STYLES = {
    height: '100%',
    marginLeft: FR_NAVIGATION_WIDTH,
};

export const DEFAULT_FR_NAV_STYLES = {
    width: FR_NAVIGATION_WIDTH,
};
